<div>
  <h3>{{ templateTitle }}</h3>
  <br />
  <ckeditor type="text" [(ngModel)]="templateContent"></ckeditor>
</div>
